
export const showInventoryText = (item) => {
    if (item) {
        return !!((!!item.policyFlag && item.productPolicyList && item.productPolicyList.length > 0)||(!!item.policyVariousFlag && item.policyVariousList && item.policyVariousList.length > 0))
    }
    return false
 
}
export const showInventoryTip = (item) => {
    let remark = []
  if (item) {
      if(item.productPolicyList&&item.productPolicyList.length&&item.productPolicyList[0].remark){
        remark.push(item.productPolicyList[0].remark)
      }
      if(item.policyVariousList&&item.policyVariousList.length){
        item.policyVariousList.forEach(item=>{
           if(item.remark){
             
             remark.push(item.remark)
           }
        })
       
      }

  }
  return !!remark.length?remark.join(';'):''
}